import { render, staticRenderFns } from "./PTOViewCompany.vue?vue&type=template&id=212e5fed&scoped=true&"
import script from "./PTOViewCompany.vue?vue&type=script&lang=ts&"
export * from "./PTOViewCompany.vue?vue&type=script&lang=ts&"
import style0 from "./PTOViewCompany.vue?vue&type=style&index=0&id=212e5fed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e5fed",
  null
  
)

export default component.exports